export const joinUrl = (base: string, path: string): string => {
  // Remove trailing slashes from base URL and leading slashes from path
  const sanitizedBase = base?.replace(/\/+$/, '') ?? '' // Remove trailing /
  const sanitizedPath = path?.replace(/^\/+/, '') ?? '' // Remove leading /

  // Concatenate with a single '/'
  return `${sanitizedBase}/${sanitizedPath}`
}
